import { motion } from "framer-motion";
import RevealLine from "./RevealLine";
import Countdown from "./Countdown";
import { DISTRICT_URL, FLYER_URL } from "@/lib/links";

const fade = (delay) => ({
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

const Hero = () => (
  <section data-testid="hero-section" className="relative overflow-hidden bg-night">
    <img
      src={FLYER_URL}
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 h-full w-full scale-125 object-cover opacity-40 blur-3xl saturate-[1.2]"
    />
    <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(14,9,8,0.55)_0%,rgba(14,9,8,0.75)_60%,#0E0908_100%)]" />

    <header className="relative z-20 flex items-center justify-between px-5 sm:px-10 py-5 sm:py-6">
      <span className="font-display font-bold text-base sm:text-lg tracking-[0.25em] text-bone" data-testid="nav-wordmark">
        HUGEL
      </span>
      <span className="eyebrow whitespace-nowrap" data-testid="hero-eyebrow">
        Official India Tour<span className="hidden sm:inline"> · Kolkata</span>
      </span>
    </header>

    <div className="relative z-10 mx-auto max-w-6xl px-5 sm:px-10 pb-20 pt-2 sm:pt-6 lg:pb-20 lg:min-h-[calc(100vh-88px)] grid lg:grid-cols-[minmax(0,520px)_1fr] gap-10 lg:gap-20 items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        className="relative mx-auto w-full max-w-[520px]"
      >
        <video
          src="/hero-loop.mp4"
          poster="/hero-poster.jpg"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="HUGEL — Kolkata, stay sexy. We're movin' to the sun."
          data-testid="hero-flyer-video"
          className="w-full aspect-square object-cover shadow-[0_30px_80px_rgba(0,0,0,0.6)]"
        />
      </motion.div>

      <div>
        <h1 className="font-display font-bold uppercase leading-[1.02] tracking-tight text-bone text-[2rem] sm:text-5xl lg:text-[2.75rem] xl:text-[3.1rem]">
          <RevealLine delay={0.2} className="whitespace-nowrap" testid="hero-date">Fri 25 Dec 2026</RevealLine>
          <RevealLine delay={0.32} className="text-coral" testid="hero-venue">RCTC, Kolkata Racecourse</RevealLine>
        </h1>

        <motion.p {...fade(0.5)} className="mt-6 font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] text-sand" data-testid="hero-time">
          Doors 5:30 PM · 18+
        </motion.p>

        <motion.div {...fade(0.65)} className="mt-10">
          <Countdown />
        </motion.div>

        <motion.div {...fade(0.8)} className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
          <a
            id="hero-cta"
            data-testid="hero-district-ticket-button"
            href={DISTRICT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ticket w-full sm:w-auto px-10 py-4 text-sm sm:text-base"
          >
            Get Tickets
          </a>
          <span className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.2em] text-sand" data-testid="hero-price-anchor">
            From ₹2,499
          </span>
        </motion.div>

        <motion.a
          {...fade(0.95)}
          href="#tables"
          data-testid="hero-tables-link"
          className="mt-7 inline-block font-mono text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-ash underline underline-offset-4 decoration-ash/40 hover:text-coral hover:decoration-coral transition-colors duration-300"
        >
          Tables &amp; Lounge enquiries ↓
        </motion.a>
      </div>
    </div>
  </section>
);

export default Hero;
